export const CREATE_PROJECTS_BANNER = `Your projects have been successfully created. Take another look at your categories to see if they should be billable or not.`;
export const UPDATE_PROJECTS_BANNER = `Projects successfully updated!`;
